import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import {
  setShowPageCollapsingHeader,
  setIsSubMenuDropDownContent,
} from './actions';

const showPageCollapsingHeaderSelector = (state) =>
  state.pageCollapsingHeader || false;

export const usePageCollapsingHeader = {
  state: () => {
    return useSelect(showPageCollapsingHeaderSelector);
  },
  actions: () => {
    return {
      setShowPageCollapsingHeader: useAction(setShowPageCollapsingHeader),
      setIsSubMenuDropDownContent: useAction(setIsSubMenuDropDownContent),
    };
  },
};
